import { useNavigate } from 'react-router'
import { KeyboardArrowRight } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Button, Typography, useMediaQuery, useTheme } from '@mui/material'

import BackButton from '../../components/back-button'
import HelpIconUrl from '../../components/help-icon-url'
import ScreenContainer from '../../components/screen'
import SensorActivationFooter from '../../components/sensor-activation-footer'
import AmazonSidewalkBanner from '../../images/amazon-sidewalk.svg'
import { useActivationContext } from '../../providers/activation-provider'
import { SHORT_SCREEN_HEIGHT } from '../../utils/constants'

import useStyles from './index.styles'

const AmazonSidewalk = () => {
  const classes = useStyles
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()
  const isShortScreen = useMediaQuery(`(max-height:${SHORT_SCREEN_HEIGHT})`)
  const theme = useTheme()

  return (
    <ScreenContainer
      useDarkBackground={true}
      footerSpacing={148}
      headerProps={{
        title: '',
        leftIcon: <BackButton />,
        rightIcon: <HelpIconUrl url="https://resources.meshify.com/defender-slim/#amazon" />,
        useDarkBackground: true,
        progress: 6,
      }}
    >
      <img src={AmazonSidewalkBanner} alt="Amazon Sidewalk Banner" style={classes.banner} />

      <Typography variant="h6" sx={classes.sidewalkText}>
        Your sensor connects through&nbsp;
        <strong>Amazon Sidewalk</strong> not Wi-Fi. Sidewalk is a secure community network powered by nearby&nbsp;
        <strong>Echo and Ring.</strong>
      </Typography>

      <Typography variant="body2" sx={classes.noteText}>
        Note: It's okay if you don't have those devices. Your sensor can use compatible Sidewalk devices nearby
      </Typography>

      <Typography variant="body2" sx={classes.instructionText}>
        Here’s how to see if Sidewalk is enabled:
      </Typography>

      <Accordion sx={classes.sidewalkAccordion}>
        <AccordionSummary expandIcon={<KeyboardArrowRight sx={classes.accordionIcon} />} sx={classes.sidewalkAccordionSummary}>
          <Typography sx={classes.accordionTitle}>Ring app</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Typography variant="body2" component="div">
            <ol style={classes.orderedList}>
              <li>Open Ring app</li>
              <li>
                Tap <strong>Menu icon (≡)</strong>
              </li>
              <li>
                Select <strong>Control Center</strong>
              </li>
              <li>
                Scroll down and tap <strong>Amazon Sidewalk</strong>
              </li>
              <li>
                Make sure button is toggled to <strong>On</strong>
              </li>
            </ol>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={classes.sidewalkAccordion}>
        <AccordionSummary expandIcon={<KeyboardArrowRight sx={classes.accordionIcon} />} sx={classes.sidewalkAccordionSummary}>
          <Typography sx={classes.accordionTitle}>Alexa app</Typography>
        </AccordionSummary>

        <AccordionDetails>
          <Typography variant="body2" component="div">
            <ol style={classes.orderedList}>
              <li>Open Alexa app</li>
              <li>
                Tap <strong>Menu icon (≡)</strong>
              </li>
              <li>
                Tap <strong>Settings</strong>
              </li>
              <li>
                Go to <strong>Account Settings{'>'} Amazon Sidewalk</strong>
              </li>
              <li>
                Make sure button is toggled to <strong>On</strong>
              </li>
            </ol>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <SensorActivationFooter
        primaryButton={
          <Button variant="contained" disableElevation color="secondary" onClick={() => navigate('/higher-floor', { state: activationLocationState })}>
            Next
          </Button>
        }
        sxFooter={{
          height: isShortScreen ? 'auto' : undefined,
          paddingBottom: isShortScreen ? theme.spacing(2) : undefined,
        }}
      />
    </ScreenContainer>
  )
}

export default AmazonSidewalk
